import { cartAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { TCartItem } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';
import { getAuthenticationConfig } from '../../utils/getAuthenticationConfig';

export interface GetCartOptions {
  queryParams: {
    skipSync: boolean;
    includePrices: boolean;
  };
}

export const getCart = async (options: GetCartOptions) => {
  const path = endpointReplace({ ':siteType': SiteTypes.CART }, Endpoints.GetCart);
  const authentication = await getAuthenticationConfig();

  const response = await network.get<TCartItem[]>(`${path}`, {
    params: options.queryParams,
    ...authentication,
  });

  return response.data;
};
